import { MDText } from 'i18n-react';

import { DateSelectionIndicatorProps } from './DateSelectionIndicator';
import LocalTexts from './DateSelectionIndicator.texts.json';

const LocalT = new MDText(LocalTexts);

export const THRESHOLD_LEVEL = {
  EMPTY: 'empty',
  EXCELLENT: 'excellent',
  GOOD: 'good',
  GREAT: 'great',
  LOW: 'low',
  VERY_LOW: 'vlow',
} as const;

type ThresholdLevel = typeof THRESHOLD_LEVEL[keyof typeof THRESHOLD_LEVEL];
type ThresholdLevelConfig = { level: ThresholdLevel, selectedDates: number }[]
type ThresholdLevelProps = Omit<DateSelectionIndicatorProps, 'expiryTime'> & { config?: ThresholdLevelConfig }

export const THRESHOLD_LEVEL_INFO: Record<ThresholdLevel, { info?: React.ReactNode, score: React.ReactNode }> = {
  [THRESHOLD_LEVEL.VERY_LOW]: {
    info: LocalT.translate('thresholdLevels.vlow.info'),
    score: LocalT.translate('thresholdLevels.vlow.score'),
  },
  [THRESHOLD_LEVEL.LOW]: {
    info: LocalT.translate('thresholdLevels.low.info'),
    score: LocalT.translate('thresholdLevels.low.score'),
  },
  [THRESHOLD_LEVEL.GOOD]: {
    info: LocalT.translate('thresholdLevels.good.info'),
    score: LocalT.translate('thresholdLevels.good.score'),
  },
  [THRESHOLD_LEVEL.GREAT]: {
    info: LocalT.translate('thresholdLevels.great.info'),
    score: LocalT.translate('thresholdLevels.great.score'),
  },
  [THRESHOLD_LEVEL.EXCELLENT]: {
    info: LocalT.translate('thresholdLevels.excellent.info'),
    score: LocalT.translate('thresholdLevels.excellent.score'),
  },
  [THRESHOLD_LEVEL.EMPTY]: {
    score: LocalT.translate('thresholdLevels.empty'),
  },
};

const DEFAULT_LEVEL_CONFIG: ThresholdLevelConfig = [
  {
    level: THRESHOLD_LEVEL.EMPTY,
    selectedDates: 0,
  },
  {
    level: THRESHOLD_LEVEL.LOW,
    selectedDates: 1,
  },
  {
    level: THRESHOLD_LEVEL.GOOD,
    selectedDates: 3,
  },
  {
    level: THRESHOLD_LEVEL.EXCELLENT,
    selectedDates: 4,
  },
];

export const getThreshold = ({ config = DEFAULT_LEVEL_CONFIG, selectedCount }: ThresholdLevelProps) => {
  const thresholdConfig = [...config]
    .sort((a, b) => b.selectedDates - a.selectedDates) // Sort in reverse date order.
    .find((configItem) => selectedCount >= configItem.selectedDates);

  const { level } = thresholdConfig!;

  const { info, score } = THRESHOLD_LEVEL_INFO[level];

  return {
    level,
    levelInfo: info,
    levelScore: score,
  };
};
